import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ecmo-modification-request',
  templateUrl: './modification-request.component.html',
  styleUrls: ['./modification-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModificationRequestComponent {}
